import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Radio } from '../../../../../CommonComponents/OPL/Radio/Radio';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { InsuranceDTO } from '../../../api/useInsuranceQuery';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';

interface Props {
  data: InsuranceDTO;
}

export const DisabilityInsurancePolicyType = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="DisabilityInsurancePolicyType"
      render={({ field: { value, onChange } }) => {
        return (
          <Box as="fieldset" border="none" p={0}>
            <Text
              as="legend"
              variant="formLabel"
              color="neutral.600"
              css="display: block"
              mb="4"
              p="0"
            >
              Policy Type
            </Text>

            <Box display="flex">
              {data.Options.DisabilityInsurancePolicyTypeOptions.map(({ value: v, label }) => (
                <Radio
                  key={label}
                  name="DisabilityInsurancePolicyType"
                  checked={value === v}
                  onChange={() => onChange(v)}
                  mr="8"
                >
                  {label}
                </Radio>
              ))}
            </Box>
          </Box>
        );
      }}
    />
  );
};
